import * as React from 'react';
import './AccountPassword.scss';
import AccountInfoHeader from '../AccountInfoHeader';
import AccountInfoFooter from '../AccountInfoFooter';
import Button from 'src/components/common/Button';
import Input from 'src/components/common/Input';
import { INewPasswordValidation } from 'src/model/modules/accountview.model';
import { goToForgot, goToRedirect } from 'src/utils/navigation';
import Loader from 'src/components/common/Loader';
import Alert from 'src/pages/ForgotPasswordView/components/Alert';

interface IAccountPasswordProps {
  isLoading: boolean;
  hasError: boolean;
  currentPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
  passwordValidation: INewPasswordValidation;
  onCurrentPasswordChange(value: string): void;
  onNewPasswordChange(value: string): void;
  onNewPasswordRepeatChange(value: string): void;
  onChangePassword(cb?: (result: boolean) => void): void;
  onClearError(): void;
  t?: any;
}

export function AccountPassword(props: IAccountPasswordProps) {
  const { t } = props;
  const handleOnPasswordChanged = (result: boolean) => {
    goToRedirect();
  };

  const invalid =
    props.passwordValidation.dirty && !props.passwordValidation.valid;
  return (
    <div className="rp-accountpassword">
      {props.isLoading ? <Loader /> : null}
      <AccountInfoHeader />

      {props.hasError ? (
        <Alert type="error" icon="rpds-error" onClose={props.onClearError}>
          We couldn't change your password, please make sure you entered your
          current password correctly.
        </Alert>
      ) : null}
      <div className="rp-accountpassword--content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-8">
              <h1>{t('accountManagePassword.changePasswordTitle')}</h1>
              <p className="rp-accountpassword--subtitle">
                {t('accountManagePassword.description')}
              </p>
            </div>
            {/* <div className="col-12 col-md-4">
              <Button
                label="Forgot Password"
                textTransform="capitalize"
                buttonClass="secondary-button rp-accountpassword--resetbtn"
                height="48px"
                icon={{
                  position: "left",
                  icon: "rpds rpds-repeat"
                }}
                action={goToForgot}
              />
            </div> */}
          </div>
          <div className="row">
            <div className="col-12 col-md-4">
              <Input
                label={t('accountManagePassword.currentPassword')}
                value={props.currentPassword}
                type="password"
                onChange={props.onCurrentPasswordChange}
              />

              <Input
                label={t('accountManagePassword.newPassword')}
                value={props.newPassword}
                type="password"
                onChange={props.onNewPasswordChange}
                invalid={invalid}
                invalidMessage={props.passwordValidation.message}
              />

              <Input
                label={t('accountManagePassword.reEnterPassword')}
                value={props.newPasswordRepeat}
                type="password"
                onChange={props.onNewPasswordRepeatChange}
                invalid={invalid}
                invalidMessage={props.passwordValidation.message}
              />

              <Button
                label={t('accountManagePassword.changePasswordActionTxt')}
                textTransform="uppercase"
                buttonClass="primary-button"
                height="48px"
                action={() => props.onChangePassword(handleOnPasswordChanged)}
                disabled={!props.passwordValidation.valid}
              />
            </div>
          </div>
        </div>
      </div>

      <AccountInfoFooter />
    </div>
  );
}
